import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  TextField,
  IconButton,
  Checkbox,
  FormControlLabel,
  Autocomplete,
} from "@mui/material";
import { motion } from "framer-motion";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import configServ from "../../services/config";
import { useSelector } from "react-redux";
import imgicon from "../../Components/Assets/images/imageicon.jpg";
import { toast } from "react-hot-toast";
import LoaderBackdrop from "../../Components/Loader/LoaderBackdrop";
const InventoryTransformation = ({ isCreate, setIsCreate }) => {
  const [items, setItems] = useState([]);
  const [units, setUnits] = useState([]);
  const { company_id,user_id } = useSelector((state) => state.GlobalVariables);
const [loading,setLoading] = useState(false)
  const [inputItems, setInputItems] = useState([
    {
      itemName: "",
      quantity: "",
      unitPrice: "",
      unit: "",
      associatedItems: [],
      itemtotalprice: "",
    },
  ]);

  const [outputItems, setOutputItems] = useState([
    {
      productName: "",
      quantity: "",
      costPrice: "",
      unit: "",
      isTaxInclusive: true,
      newcostprice: "",
    },
  ]);

  const [imagePreview, setImagePreview] = useState(imgicon);
  const [imageBase64, setImageBase64] = useState("");
  const [totalInputCost, setTotalInputCost] = useState(0);
  const fileInputRef = useRef(null);
  const fetchItemList = async () => {
    try {
      const dataToSend = {
        company_id,
        search_by: null,
        search: null,
        per_page: null,
        page: null,
      };
      const res = await configServ.getItemList(dataToSend);
      if (res.status === 200 && res.data.length > 0) {
        setItems(res.data);
        const unitSet = new Set(
          res.data.map((item) => item.unit).filter(Boolean)
        );
        setUnits([...unitSet]);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (isCreate) {
      fetchItemList();
    }
  }, [isCreate]);

  const handleInputChange = (index, field, value) => {
    const updatedItems = [...inputItems];
    const numberFields = ["quantity"];
    updatedItems[index][field] = numberFields.includes(field)
      ? value === ""
        ? ""
        : Number(value)
      : value;
    // Recalculate itemtotalprice if quantity or unitPrice changes
    const quantity =
      field === "quantity" ? value : updatedItems[index].quantity;
    const unitPrice =
      field === "unitPrice" ? value : updatedItems[index].unitPrice;
    updatedItems[index].itemtotalprice = quantity * unitPrice || 0;
    setInputItems(updatedItems);
    calculateTotalInputCost(updatedItems);
  };

  const handleAssociatedItemChange = (mainIndex, aIndex, field, value) => {
    const updated = [...inputItems];
    updated[mainIndex].associatedItems[aIndex][field] = value;
    setInputItems(updated);
  };

  const handleItemSelect = async (index, selectedItem) => {
    if (!selectedItem) return;

    const updatedItems = [...inputItems];

    // base item data
    updatedItems[index] = {
      ...updatedItems[index],
      item_id: selectedItem.id,
      itemName: selectedItem.item_name,
      unitPrice: selectedItem.costprice,
      quantity: 1,
      unit: selectedItem.unit || "",
      associatedItems: [],
      itemtotalprice: selectedItem.costprice * 1, // default qty = 1
    };

    // if (selectedItem.isItemAssociated === 1) {
    //   const associated = await fetchAssociatedItem(selectedItem.id);

    //   // 🛠 Map each associated item to include full item data from `items`
    //   const enrichedAssociated = associated.map((aItem) => {
    //     const matchedItem = items.find((itm) => itm.id === aItem.item_id);

    //     return {
    //       ...aItem,
    //       item_name: matchedItem?.item_name || aItem.item_name,
    //       unitPrice: matchedItem?.rate_unit || "",
    //       unit: matchedItem?.unit || "",
    //     };
    //   });

    //   updatedItems[index].associatedItems = enrichedAssociated;
    // }

    setInputItems(updatedItems);
    calculateTotalInputCost(updatedItems);
  };

  const fetchAssociatedItem = async (itemId) => {
    try {
      const response = await configServ.getAssociateItem({
        associatedWith_id: itemId,
      });
      return response;
    } catch (e) {
      console.log(e);
      return [];
    }
  };

  const handleAddItem = () => {
    setInputItems([
      ...inputItems,
      {
        itemName: "",
        quantity: "",
        unitPrice: "",
        unit: "",
        associatedItems: [],
        itemtotalprice: "",
      },
    ]);
  };

  const handleRemoveItem = (index) => {
    const updatedItems = inputItems.filter((_, i) => i !== index);
    setInputItems(updatedItems);
    calculateTotalInputCost(updatedItems);
  };

  const handleOutputChange = (index, field, value) => {
    const updated = [...outputItems];

    // Convert only certain fields to number
    const numberFields = ["quantity", "newcostprice", "costPrice"];

    updated[index][field] = numberFields.includes(field)
      ? value === ""
        ? ""
        : Number(value)
      : value;

    setOutputItems(updated);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setImageBase64(reader.result);
      setImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleReset = () => {
    setInputItems([
      {
        itemName: "",
        quantity: "",
        unitPrice: "",
        unit: "",
        itemtotalprice: "",
      },
    ]);
    setOutputItems([
      {
        productName: "",
        quantity: "",
        costPrice: "",
        unit: "",
        isTaxInclusive: true,
        newcostprice: "",
      },
    ]);
    setImageBase64("");
    setImagePreview(imgicon);
    // Clear file input
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    setTotalInputCost(0);
  };

  const handleSubmit = async () => {
    // Validate inputItems one by one
    for (let i = 0; i < inputItems.length; i++) {
      const item = inputItems[i];
      if (!item.item_id) {
        toast.error(`Source Items ${i + 1}: Item not selected`);
        return;
      }
      if (!item.itemName) {
        toast.error(`Source Items ${i + 1}: Item name is missing`);
        return;
      }
      if (!item.unit) {
        toast.error(`Source Items ${i + 1}: Unit is missing`);
        return;
      }
      if (!item.quantity) {
        toast.error(`Source Items ${i + 1}: Quantity is missing`);
        return;
      }
      if (!item.unitPrice) {
        toast.error(`Source Items ${i + 1}: Unit price is missing`);
        return;
      }
      if (!item.itemtotalprice) {
        toast.error(`Source Items ${i + 1}: Item total price is missing`);
        return;
      }
    }

    // Validate output item
    const output = outputItems[0];
    if (!output.product_id) {
      toast.error("Manufactured Product: Product not selected");
      return;
    }
    if (!output.productName) {
      toast.error("Manufactured Product: Product name is missing");
      return;
    }
    if (!output.unit) {
      toast.error("Manufactured Product: Unit is missing");
      return;
    }
    if (!output.quantity) {
      toast.error("Manufactured Product: Quantity is missing");
      return;
    }
    if (!output.costPrice) {
      toast.error("Manufactured Product: Previous cost price is missing");
      return;
    }
    if (!output.newcostprice) {
      toast.error("Manufactured Product: New cost price is missing");
      return;
    }

    // Validate image
    if (!imageBase64) {
      toast.error("Image is required. Please upload an image.");
      return;
    }

    // All validations passed — send data
    const payload = {
      company_id: company_id,
      inputs: inputItems,
      outputs: outputItems,
      totalInputCost: totalInputCost,
      imageBase64: imageBase64,
      created_by:user_id,
    };
    console.log("payload",payload)

    try {
      setLoading(true)
      const result = await configServ.storeManufacturedProduct(payload);
      if(result.success){
        toast.success("Data saved successfully!");
        handleReset();
        setIsCreate(!isCreate)
      }
      // Optional: reset form here
    } catch (e) {
      console.log("Error saving:", e);
      toast.error("Something went wrong while saving data.");
    }finally{
      setLoading(false)
    }
  };

  const calculateTotalInputCost = (items) => {
    const total = items.reduce(
      (sum, item) => sum + (parseFloat(item.itemtotalprice) || 0),
      0
    );
    setTotalInputCost(total);
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95, y: -20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.95, y: -20 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      style={{
        width: "100%",
        backgroundColor: "#e3f3fc",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <LoaderBackdrop open={loading} />
      <Box>
        <Grid container spacing={4} mt={2}>
          <Grid item xs={12}>
            <Box
              sx={{
                border: "1px solid #ccc",
                borderRadius: "8px",
                p: 2,
                background: "#fff",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Manufactured Product
              </Typography>

              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} md={4}>
                  <Autocomplete
                    options={items}
                    getOptionLabel={(option) =>
                      `${option.item_name} (${option.item_code})`
                    }
                    onChange={(e, selectedItem) => {
                      if (!selectedItem) return;
                      const updated = [...outputItems];
                      updated[0] = {
                        ...updated[0],
                        product_id: selectedItem.id,
                        productName: selectedItem.item_name,
                        costPrice: selectedItem.rate_unit,
                        unit: selectedItem.unit || "",
                        quantity: 1,
                        newcostprice: "",
                      };
                      setOutputItems(updated);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Product Name"
                        size="small"
                      />
                    )}
                    value={
                      items.find(
                        (x) => x.item_name === outputItems[0].productName
                      ) || null
                    }
                  />
                </Grid>

                <Grid item xs={6} md={2}>
                  <TextField
                    label={
                      outputItems[0].unit ? outputItems[0].unit : "Quantity"
                    }
                    fullWidth
                    type="number"
                    size="small"
                    value={outputItems[0].quantity}
                    onChange={(e) =>
                      handleOutputChange(0, "quantity", e.target.value)
                    }
                  />
                </Grid>

                {/* <Grid item xs={6} md={2}>
                  <Autocomplete
                    options={units}
                    getOptionLabel={(option) => option}
                    value={outputItems[0].unit || ""}
                    onChange={(e, newValue) =>
                      handleOutputChange(0, "unit", newValue)
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Unit" size="small" />
                    )}
                  />
                </Grid> */}

                <Grid item xs={6} md={2}>
                  <TextField
                    label={`Prev.Rate ₹${outputItems[0].costPrice || 0}`}
                    fullWidth
                    type="number"
                    size="small"
                    value={outputItems[0].newcostprice}
                    // value={totalInputCost}
                    onChange={(e) =>
                      handleOutputChange(0, "newcostprice", e.target.value)
                    }
                    // InputProps={{ readOnly: true }}
                  />
                </Grid>

                <Grid item xs={6} md={2} display="flex" alignItems="center">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={outputItems[0].isTaxInclusive}
                        onChange={(e) =>
                          handleOutputChange(
                            0,
                            "isTaxInclusive",
                            e.target.checked
                          )
                        }
                      />
                    }
                    label="Inclusive Tax"
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box
              sx={{
                border: "1px solid #ccc",
                borderRadius: "8px",
                p: 2,
                background: "#fff",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Source Items
              </Typography>
              {inputItems.map((item, index) => (
                <React.Fragment key={index}>
                  <Grid container spacing={2} mb={1}>
                    <Grid item xs={6} md={4}>
                      <Autocomplete
                        options={items}
                        getOptionLabel={(option) =>
                          `${option.item_name} (${option.item_code})`
                        }
                        onChange={(e, value) => handleItemSelect(index, value)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Item Name"
                            size="small"
                          />
                        )}
                        value={
                          items.find((x) => x.item_name === item.itemName) ||
                          null
                        }
                      />
                    </Grid>

                    <Grid item xs={3} md={2}>
                      <TextField
                        label={item.unit ? item.unit : "Quantity"}
                        fullWidth
                        type="number"
                        size="small"
                        value={item.quantity}
                        onChange={(e) =>
                          handleInputChange(index, "quantity", e.target.value)
                        }
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <TextField
                        label={`unit price ₹${item.unitPrice || 0}`}
                        fullWidth
                        type="number"
                        size="small"
                        value={item.quantity * item.unitPrice || 0}
                        // onChange={(e) =>
                        //   handleInputChange(index, "itemtotalprice", e.target.value)
                        // }
                        InputProps={{ readOnly: true }}
                      />
                    </Grid>

                    <Grid item xs={1}>
                      <IconButton
                        color="error"
                        onClick={() => handleRemoveItem(index)}
                        disabled={inputItems.length === 1 && index === 0}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>

                    {index === inputItems.length - 1 && (
                      <Grid item xs={1}>
                        <IconButton
                          sx={{ color: "green" }}
                          onClick={handleAddItem}
                        >
                          <AddCircleIcon />
                        </IconButton>
                      </Grid>
                    )}
                  </Grid>

                  {/* {item.associatedItems?.length > 0 && (
                    <Grid container spacing={2} pl={3} mb={2}>
                      {item.associatedItems.map((aItem, aIndex) => (
                        <Grid container spacing={2} key={aIndex} sx={{ mt: 1 }}>
                          <Grid item xs={6} md={4}>
                            <TextField
                              label="Associated Item"
                              fullWidth
                              size="small"
                              value={aItem.item_name}
                              onChange={(e) =>
                                handleAssociatedItemChange(
                                  index,
                                  aIndex,
                                  "item_name",
                                  e.target.value
                                )
                              }
                            />
                          </Grid>
                          <Grid item xs={3} md={2}>
                            <TextField
                              label={aItem.unit || "Quantity"}
                              fullWidth
                              size="small"
                              type="number"
                              value={aItem.qty || ""}
                              onChange={(e) =>
                                handleAssociatedItemChange(
                                  index,
                                  aIndex,
                                  "qty",
                                  e.target.value
                                )
                              }
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <TextField
                              label="Unit Price"
                              fullWidth
                              size="small"
                              type="number"
                              value={aItem.unitPrice || ""}
                              onChange={(e) =>
                                handleAssociatedItemChange(
                                  index,
                                  aIndex,
                                  "unitPrice",
                                  e.target.value
                                )
                              }
                            />
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>
                  )} */}
                </React.Fragment>
              ))}
              <Typography variant="subtitle1" fontWeight="bold" mt={2}>
                Total Input Cost: ₹{totalInputCost}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box
              sx={{
                border: "1px dashed #aaa",
                borderRadius: "8px",
                p: 2,
                background: "#fff",
                textAlign: "center",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Upload Image
              </Typography>
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleImageUpload}
              />
              {imagePreview && (
                <Box mt={2}>
                  <img
                    src={imagePreview}
                    alt="Preview"
                    style={{
                      maxWidth: "50%",
                      height: "20%",
                      borderRadius: "8px",
                    }}
                  />
                </Box>
              )}
            </Box>
          </Grid>
        </Grid>

        <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="outlined" color="secondary" onClick={handleReset}>
            Reset
          </Button>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Save
          </Button>
        </Box>
      </Box>
    </motion.div>
  );
};

export default InventoryTransformation;
